export default (item) => {
    if (typeof item === "string") {
        return item.toLowerCase();
    }
    return item;
};
